import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Box } from '@mui/material';

const AlFormField = (props) => {
    const { field, alTooltip, alTooltipOut, className, required, children, alRef, ...fieldProps } = props;

    const hostStyles = {
        position: 'relative',
    };

    const tooltipStyles = {
        position: 'absolute',
        padding: '0 6px',
        top: '2px',
        right: '4px',
        ...(alTooltipOut && { top: '-7px', right: '-24px' }),
    };

    const asteriskStyles = {
        position: 'absolute',
        top: '9px',
        right: '6px',
        lineHeight: '10px',
        ...(alTooltip && !alTooltipOut && { right: '22px' }),
    };

    return (
        <Box ref={alRef} className={className} sx={hostStyles}>
            {React.createElement(field, fieldProps, children)}
            {alTooltip && (
                <Tooltip title={alTooltip} placement="top" enterTouchDelay={0} leaveTouchDelay={3000}>
                    <Box sx={tooltipStyles}>
                        <HelpOutlineOutlinedIcon sx={{ fontSize: '16px', color: 'text.secondary' }} />
                    </Box>
                </Tooltip>
            )}
            {required && <Box sx={asteriskStyles}>*</Box>}
        </Box>
    );
};

export { AlFormField };
